<template>
  <div style="padding: 0 24px 26px 24px ">
    <search-list @findData="findData" ></search-list>
    <table-list
      title="" :columns="columns" :data="dataTable"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage"
    ></table-list>
  </div>
</template>
<script>
  import SearchList from './components/SearchList'
  import TableList from "components/TableList/index";
  import {getLogList} from "../../../api/log";
  import {formatDateTime} from '@/utils/format'

  export default {
    name: "log",
    components:{
      SearchList,
      TableList,
    },

    data(){
      return {
        page:1,
        current: 1,
        total: 0,
        dataTable: [],
        loading: false,
        columns:[
          {
            type: "index",
            key: "index",
            width: 60,
            align: "center"
          },
          {title:' '},
          {
            title:'用户Code',
            key:'userCode',
            align:'center',
            width: 150,
          },
          {title:' '},
          {
            title:'用户名',
            key:'userName',
            align:'center',
            width: 100,
          },
          {title:' '},
          {
            title:'操作',
            key:'operation',
            align:'center',
            width: 220,
          },
          {title:' '},
          {
            title:'响应时间 (ms)',
            key:'time',
            align:'center',
            width: 120,
          },
          {title:' '},
          {
            title:'方法',
            key:'method',
            width: 500,
          },
          {title:' '},
          {
            title:'参数',
            key:'params',
            width: 350,
            render: (h, params) => {
              if (params.row['params'] && params.row['params'].length > 50) {
                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['params']),
                  h('span', {}, params.row['params'].slice(0, 50) + '...')
                ])

              }
              else {
                return h('span', {}, params.row['params'])
              }
            }
          },
          {title:' '},
          {
            title:'IP地址',
            key:'ip',
            align:'center',
            width: 120,
          },
          {title:' '},
          {
            title:'创建时间',
            key:'createTime',
            align:'center',
            width: 180,
            render:(h,params) => {
              return h('span',formatDateTime(params.row.createTime,true))
            }
          },
        ],
        searched:null,
      }

    },
    methods:{
      findData(data){
        this.page=1;
        this.current=1;
        this.getLogList(data)
      },
      getLogList(data){
        let params={
          ...data,
          page:this.page,
          limit:10
        };
        getLogList(params).then(res=>{
          if(!res.data){
            return
          }
          this.dataTable=res.data.rows;
          this.total=res.data.total;
          this.searched=params
        }).catch(error=>{})
      },

      changePage(n){
        this.current = n;
        this.page = n;
        this.getLogList(this.searched)
      }

    }
  }
</script>

<style scoped>

</style>
